import React from 'react';

export default function HealthGauge({ score, label, size = 100 }) {
  const color = score >= 80 ? '#00b894' : score >= 60 ? '#fdcb6e' : score >= 30 ? '#e17055' : '#d63031';
  const circumference = 2 * Math.PI * 38;
  const offset = circumference - (score / 100) * circumference;

  return (
    <div style={{ textAlign: 'center' }}>
      <svg width={size} height={size} viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="38" fill="none" stroke="#eee" strokeWidth="8" />
        <circle
          cx="50" cy="50" r="38"
          fill="none"
          stroke={color}
          strokeWidth="8"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform="rotate(-90 50 50)"
          style={{ transition: 'stroke-dashoffset 0.5s' }}
        />
        <text x="50" y="48" textAnchor="middle" fontSize="22" fontWeight="700" fill={color}>
          {Math.round(score)}
        </text>
        <text x="50" y="64" textAnchor="middle" fontSize="9" fill="#999">
          {label || 'HEALTH'}
        </text>
      </svg>
    </div>
  );
}
